export function setCookie(name, value, samesite = true) {
    const date = new Date(new Date().getTime() + 3600000 * 24 * 365);
    const domain = document.location.hostname;
    const sameSite = samesite ? 'Strict' : 'None'

    document.cookie = name + "=" + value + "; path=/; domain=" + domain + "; expires=" + date.toUTCString() + "; SameSite=" + sameSite + "; Secure";
}

export function getCookie(name) {
    const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}

export function delCookie(name, samesite = true) {
    const domain = document.location.hostname;
    const expires = 'Thu, 01 Jan 1970 00:00:00 UTC';
    const sameSite = samesite ? 'Strict' : 'None'

    document.cookie = `${name}=; path=/; domain=${domain}; expires=${expires}; SameSite=${sameSite}; Secure`;
}

export function setStorageItem(key, value) {
    try {
        return window.localStorage.setItem(key, value)
    } catch (e) {
        console.log(e)
    }
}

export function getStorageItem(key, value) {
    try {
        return window.localStorage.getItem(key)
    } catch (e) {
        console.log(e)
    }
}

export async function getData(url, options = {}) {
    try {
        const res = await fetch(url, options)
        return await res.json()
    } catch (error) {
        console.log(error)
    }
}

export async function postData(url = '', data = {},  headers = {'Content-Type': 'application/json'}) {
    try {
        const response = await fetch(url, {
            method: 'POST',
            cache: 'no-cache',
            referrerPolicy: 'no-referrer',
            headers: headers,
            body: JSON.stringify(data),
        });

        return {
            'ok': response.ok,
            'status': response.status,
            'data': await response.json()
        }
    } catch (error) {
        console.error(error);
    }
}

export function scrollToBottom() {
    window.scrollTo({top: document.body.scrollHeight, behavior: 'smooth'})
}

export function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

export const isAndroidDevice = () => {
    return /Android/i.test(navigator.userAgent)
}

export function returnDay(term) {
    let date = new Date();
    date.setDate(date.getDate() + parseInt(term, 10));
    let dd = date.getDate();
    if (dd < 10) dd = '0' + dd;
    let mm = date.getMonth() + 1;
    if (mm < 10) mm = '0' + mm;
    let yy = date.getFullYear();
    return dd + '.' + mm + '.' + yy;
}

export function slideToggle(e, time = 300) {
    if (getComputedStyle(e).display === 'none') {
        slideShow(e, time);
    } else {
        slideHide(e, time);
    }
}

export function slideShow(e, time = 300) {
    e.style.overflow = 'hidden';

    if (getComputedStyle(e).display === 'none') {
        e.style.display = 'block';

        const h = +getComputedStyle(e).height.replace('px', "");

        setCss(e, '0px', '0px', '0px', '0px', '0px', '0px', '0px');

        setTimeout(() => {
            e.style.transition = time + 'ms';
            setCss(e, h + 'px');
        }, 0);

        setTimeout(() => {
            e.style.display = 'block';
            setCss(e);
            e.style.overflow = '';
            e.style.transition = '';
        }, time);
    }
}

export function slideHide(e, time = 300) {
    e.style.overflow = 'hidden';

    if (getComputedStyle(e).display !== 'none') {
        const h = +getComputedStyle(e).height.replace('px', "");

        e.style.height = h + 'px';

        setTimeout(() => {
            e.style.transition = time + 'ms';
            setCss(e, '0px', '0px', '0px', '0px', '0px', '0px', '0px');
        }, 0);


        setTimeout(() => {
            e.style.display = 'none';
            setCss(e);
            e.style.overflow = '';
            e.style.transition = '';
        }, time);
    }
}

function setCss(e, h = '', pT = '', pB = '', mT = '', mB = '', bT = '', bB = '') {
    e.style.height = h;
    e.style.paddingTop = pT;
    e.style.paddingBottom = pB;
    e.style.marginTop = mT;
    e.style.marginBottom = mB;
    e.style.borderTopWidth = bT;
    e.style.borderBottomWidth = bB;
}
